import type { ReactNode } from 'react';
import { useState } from 'react';
import { ModelStateList } from '@/utils/modelState';
import type { ScheduleEvent } from './ScheduleWrapperComponent';

export function ScheduleConditionComponent({ events }: ScheduleConditionComponentProps ) {

    const [openingScheduler, setOpeningScheduler] = useState(false);
    const [schedulerVisible, setSchedulerVisible] = useState(false);
    const [schedulerComponent, setSchedulerComponent] = useState<ReactNode | null>(null);

    async function openScheduler() {
        setOpeningScheduler(true);

        const { ScheduleWrapperComponent } = await import('./ScheduleWrapperComponent');

        setSchedulerComponent(<ScheduleWrapperComponent
            scheduleEvents={events}
            closed={() => setSchedulerVisible(false)} />);

        setOpeningScheduler(false);
        setSchedulerVisible(true);
    }

    return (
        <div>
            {schedulerComponent && schedulerVisible ? (
                schedulerComponent
            ) : null}
            <div>
                <button className="btn btn-outline-contrast" onClick={openScheduler} disabled={openingScheduler || schedulerVisible}>Open Scheduler</button>
            </div>
        </div>
    );
}

export interface ScheduleConditionComponentProps {
    events: ModelStateList<ScheduleEvent>;
}
